import React, { useState, useEffect } from 'react';
import './Nav.css';

export default function Nav() {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`nav ${scrolled ? 'nav--scrolled' : ''}`}>
      <div className="nav__inner">
        <div className="nav__logo">
          <img src="/logo.png" alt="UrajiTech" className="nav__logo-img" />
          <span className="nav__logo-text">UrajiTech</span>
        </div>
        <div className="nav__links">
          <a href="#about">О нас</a>
          <a href="#values">Ценности</a>
          <a href="#team">Команда</a>
          <a href="#join" className="nav__cta">Присоединиться</a>
        </div>
      </div>
    </nav>
  );
}
